export default __webpack_public_path__ + "static/media/iam_teacher.07c642a3.svg";